export interface AuState {
  code: string
  bbox: [number, number, number, number] // [minLon, minLat, maxLon, maxLat]
}

export const AU_STATES: AuState[] = [
  { code: 'NSW', bbox: [140.9, -37.6, 153.7, -28.1] },
  { code: 'VIC', bbox: [140.9, -39.2, 150.0, -33.9] },
  { code: 'QLD', bbox: [137.9, -29.2, 153.7, -10.7] },
  { code: 'SA',  bbox: [129.0, -38.1, 141.0, -25.9] },
  { code: 'WA',  bbox: [112.9, -35.2, 129.0, -13.7] },
  { code: 'TAS', bbox: [143.8, -43.7, 148.5, -39.2] },
  { code: 'NT',  bbox: [129.0, -26.0, 138.0, -10.9] },
  { code: 'ACT', bbox: [148.7, -35.9, 149.4, -35.1] },
]

export const AU_BBOX: [number, number, number, number] = [112.9, -43.7, 153.6, -10.7]
